import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import ToggleSwitch from 'app/components/shared/ToggleSwitch';

const EditorHasAlternativeBackgroundToggle = ({ className, onChange, value }) => {
  const handleHasAlternativeBackgroundChange = event => {
    onChange(event.target.checked);
  };

  const inputId = useMemo(() => uniqueId('EditorHasAlternativeBackground_'), []);
  // TODO: localize
  const localizedToggleLabel = 'Grey background';

  return (
    <ToggleSwitch
      active={value}
      activeText={localizedToggleLabel}
      className={className}
      handleClick={handleHasAlternativeBackgroundChange}
      id={inputId}
      inactiveText={localizedToggleLabel}
    />
  );
};

EditorHasAlternativeBackgroundToggle.defaultProps = {
  className: ''
};

EditorHasAlternativeBackgroundToggle.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired
};

export default EditorHasAlternativeBackgroundToggle;
